import { GlobalStyles } from '@experiences/theme';
import { UiText } from '@experiences/ui-common';
import Info from '@mui/icons-material/Info';
import { makeStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import React from 'react';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
    ...GlobalStyles(theme),
    ...createStyles({
        textBox: {
            display: 'flex',
            flexDirection: 'row',
            fontSize: '12px',
            color: theme.palette.semantic.colorForegroundDeEmp,
            marginTop: '20px',
            textAlign: 'justify',
            width: '387px',
            backgroundColor: theme.palette.semantic.colorChipInfoBackground,
            borderStyle: 'round',
            borderRadius: '10px',
            padding: '10px',
        },
        infoIcon: {
            marginRight: '10px',
            color: theme.palette.semantic.colorInfoIcon,
        },
    }),
}));

const EcommerceMinimumLicenseQuantityInfoComponent: React.FC<{
    width?: string;
}> = ({ width }) => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();

    return (<div
        className={classes.textBox}
        style={width ? { width } : undefined}>
        <Info className={classes.infoIcon} />
        <UiText
            data-cy="minimum-purchase-quantity-info">
            {translate(
                { id: 'CLIENT_ECOMMERCE_MINIMUM_PURCHASE_QUANTITY_INFO' },
            )}
        </UiText>
    </div>);
};

export default EcommerceMinimumLicenseQuantityInfoComponent;
